var PD = PD || {};
PD.windows = PD.windows || {};

//------------------------------------------------------------------------------
// Window class
//------------------------------------------------------------------------------
PD.windows.Window = (function (w) {
  // private window variables
  var _windowInd = 0;
  var _windows = []; // ordered by appearance - [last, ... , active]
  var _activeWindow = null;

  /**
   * Constructor for a new modal window, with custom title, content and actions.
   * @param  {String} title            Title of the window
   * @param  {String|Element} content  HTML or jQuery element to use as content for modal.
   * @param  {Object} cfg              See below for description
   * 
   * cfg: {
   *   show: {Boolean} true, // whether to immediately show the modal
   *   ignoreBackdrop: {Boolean} false, // if true, clicking the backdrop won't hide modal
   *   keyboard: {Boolean} false, // if false, the escape button won't hide the modal
   *   actions: {Array}, // array of action objects (see below) or jQuery buttons - default [{ text: "Ok", click: <Destroy self>, classes: ["btn-primary"] }]
   *   close: {Boolean} true, // if false, don't show the close button
   * }
   *
   * action: {
   *   click: {Function|String}, // function or name of function to use as onclick handler. If function, it's bound so `this` is the window instance
   *   text: {String}, // text to display inside button
   *   classes: {Array} // optional array of additional classes to give to button
   * } | <jQuery>
   *
   * The following events are emitted by the instance (actually proxies jQuery's event emitter):
   *   window:hidden - When the window has been hidden
   *   window:shown - When the window has been shown
   *   window:destroy - When the window is being removed
   */
  function Window(title, content, cfg) {
    cfg = cfg || {};
    cfg.show = cfg.show === undefined ? true : cfg.show;
    cfg.actions = cfg.actions || [{ text: "Ok", classes: ["btn-primary"], click: function(){ this.destroy(); }}];
    this.id = _windowInd;
    cfg.id = "cm-window-"+(++_windowInd);
    cfg.title = title;

    // create the containing modal element
    var $elm = this.$elm = $( $.tmpl("windowTpl", cfg) )
                  .appendTo("body");
    // fill it with content (keeps possible listeners)
    $elm.find(".cm-window-content")
        .append(content);
    // insert action buttons
    for (var i = 0; i < cfg.actions.length; ++i) {
      var action = cfg.actions[i],
          $btn = action;
      if (!(action instanceof jQuery)) {
        // TODO: rewrite?
        $btn = $("<button type='button' "+
                         "class='btn "+(action.classes||[]).join(" ")+"' "+
                         (typeof action.click === "string" ? "onclick='"+action.click+"' " : "")+
                 ">"+action.text+"</button>");
        if (typeof action.click === "function") {
          $btn.click(action.click.bind(this));
        }
      }
      $elm.find(".cm-window-actions").append($btn);
    }
    if (cfg.actions.length === 0) {
      $elm.find(".modal-footer")
        .hide();
    }
    $elm.modal({show: false});

    // bind hidden/shown listeners
    $elm.on("hidden.bs.modal", _handleHidden.bind(this));
    $elm.on("shown.bs.modal", _handleShown.bind(this));

    // proxy jQuery's event emitter
    var self = this;
    this.on = function(){
      $elm.on.apply($elm, arguments);
      return self;
    };
    this.one = function(){
      $elm.one.apply($elm, arguments);
      return self;
    };
    this.trigger = $elm.trigger.bind($elm);

    _windows.push(this);
    // show (if we should) and return
    if (cfg.show) {
      this.show();
    }
    return this;
  }

  /**
   * Show the window
   */
  Window.prototype.show = function() {
    if (this.destroyed) {
      return _warnDestroyed(this);
    }

    // remove "active" flag (see .hide)
    this.active = false;

    // hide currently active modal
    // also add style to make the change more smooth
    if (_activeWindow && this !== _activeWindow) {
      _activeWindow.one("hidden.bs.modal", function(){
        $("body").removeClass("modal-switching");
        $("body").addClass("modal-open");
      });
      _activeWindow.hide(true);
      $("body").addClass("modal-switching");
    }
    this.$elm.modal("show"); // Bootstrap's modal method
    _activeWindow = this;
  };

  /**
   * Automatically called by "shown.bs.modal" listener on window elements
   * Bound to PD.windows.Window instance it was called from
   */
  var _handleShown = function(e) {
    // send this to end of _windows list (so it's shown first when next window is closed)
    var ind = _windows.indexOf(this);
    if (ind !== -1) {
      _windows.splice(ind ,1);
    }
    _windows.push(this);

    // re-add the ".modal-open" class if it's not there
    if (!$("body").hasClass("modal-open")) {
      $("body").addClass("modal-open");
    }

    // emit "shown" event
    this.trigger("window:shown");
  };

  /**
   * Hides the window.
   * Use .destroy if you want to destroy and clean it up instead    
   * @param {Boolean} showWhenPossible  Whether the window should be shown again as soon as no other window is open
   */
  Window.prototype.hide = function(showWhenPossible) {
    if (this.destroyed) {
      return _warnDestroyed(this);
    }

    // if we were hidden because another window was opened, set active to true
    // this means that we want to be shown when no other window is open
    this.active = !!showWhenPossible;

    // _activeWindow must be set to null as quickly as possible, to avoid racing issues (eg. w1.show();w2.show())
    if (this === _activeWindow) {
      if (!showWhenPossible) {
        // if no other window is immediately placed on top
        // and we were activeWindow, show next waiting window
        this._showWaitingOnHide = true;
      }
      _activeWindow = null;
    }
    this.$elm.modal("hide");

    // most hiding logic is done in _handleHidden
  };

  /**
   * Automatically called by "hidden.bs.modal" listener on window elements
   * Bound to PD.windows.Window instance it was called from
   */
  var _handleHidden = function(e) {
    // it might seem like this is a double of the check in .hide
    // however, this handles UI-triggered hiding (ie. click on close button)
    if (this === _activeWindow) {
      _activeWindow = null;
      this._showWaitingOnHide = true;
    }

    // open first window which wants to be shown (ie. is active)
    if (this._showWaitingOnHide) {
      delete this._showWaitingOnHide;
      _openWaiting(this);
    }

    // re-add the ".modal-open" class if we have an active window
    if (_activeWindow) {
      $("body").addClass("modal-open");
    }

    // emit a "hidden" event
    this.trigger("window:hidden");
  };

  /**
   * Destroy a window's element. After this the modal can't be used any more
   * Use .hide instead if it should simply be hidden.
   */
  Window.prototype.destroy = function() {
    if (this === _activeWindow) {
      _activeWindow = null;
    }
    this.hide();

    // emit destroy event
    this.trigger("window:destroy");

    // remove the modal from our windows list
    var ind = _windows.indexOf(this);
    if (ind !== -1) {
      _windows.splice(ind, 1);
    }

    // finally remove it (and let jQuery delete all data)
    var self = this;
    this.on("hidden.bs.modal", function(){
      self.$elm.remove();
      _openWaiting(self);
    });

    // mark self as destroyed
    this.destroyed = true;
  };

  /**
   * Sets the loading state of the window
   * @param {Boolean} state
   */
  Window.prototype.setLoading = function(state) {
    this.$elm.find(".modal-dialog")
      .toggleClass("loading", state);
  };

  function _warnDestroyed(instance) {
    console.warn("[PD.windows.Window] Tried using a destroyed window:",instance);
  }
  function _openWaiting(instance) { // open first window which is waiting (ie. active). Used when a window is hidden/destroyed
    if (_windows.length) {
      var prev;
      for (var i = _windows.length - 1; i >= 0; --i) {
        var win = _windows[i];
        if (instance !== win && win.active) {
          prev = win;
          break;
        }
      }
      if (prev) {
        prev.show();
      }
    }
  }

  // overwrite Bootstrap modal's scrollbar logic
  // just reset padding every time
  var _setScrollbar = $.fn.modal.Constructor.prototype.setScrollbar;
  $.fn.modal.Constructor.prototype.setScrollbar = function(){
    // we overwrite this work anyway. If BS updates/bugs appear, try uncommenting:
    // _setScrollbar.apply(this, arguments);
    this.originalBodyPad = ""; // reset, because we never use body padding-right
    if (this.bodyIsOverflowing) {
      this.$body.css("padding-right", this.scrollbarWidth);
    }
  };
  var _resetScrollbar = $.fn.modal.Constructor.prototype.resetScrollbar;
  $.fn.modal.Constructor.prototype.resetScrollbar = function(){
    // only reset if another modal hasn't already taken over
    if (!_activeWindow || this.$element.is(_activeWindow.$elm)) {
      _resetScrollbar.apply(this, arguments);
    }
  };

  return Window;
}(PD.windows || {}));

/*$(document).ready(function() {
  PD.windows._init();
});*/
//------------------------------------------------------------------------------
